export default __webpack_public_path__ + "static/hatcat-15fb03a058cb1174db474c37ded96188.png";